import React, { useState, useEffect } from "react";
import { 
  X, 
  Crown, 
  Users, 
  Globe, 
  Linkedin, 
  Instagram, 
  Facebook, 
  Music, 
  Twitter 
} from "lucide-react";

const API_URL =
  process.env.REACT_APP_BACKEND_URL || "https://topnationapp-1-api.onrender.com";

export default function CountryModal({ country, isOpen, onClose }) {
  const [bidders, setBidders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [bidAmount, setBidAmount] = useState("1");
  const [submitting, setSubmitting] = useState(false);

  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  const isMobile = window.innerWidth < 768;

  useEffect(() => {
    if (!country || !isOpen) return;
    loadBidders();
  }, [country, isOpen]);

  const loadBidders = async () => {
    try {
      setLoading(true);

     const res = await fetch(
  `${API_URL}/api/countries/${country?.country_code || country?.code}/bidders`
);

      if (res.ok) {
        const data = await res.json();
        setBidders(data);
      } else {
        setBidders([]);
      }
    } catch (err) {
      console.error(err);
      setBidders([]);
    } finally {
      setLoading(false);
    }
  };

  const submitBid = async () => {
    if (!country) return;

    if (!termsAccepted) {
      alert("You must accept Terms & Conditions.");
      return;
    }

    try {
      setSubmitting(true);

      const token = localStorage.getItem("token");

      if (!token) {
        alert("Login first");
        return;
      }

      const response = await fetch(
  `${API_URL}/api/countries/${country?.country_code || country?.code}/bid`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            amount: Number(bidAmount),
            origin_url: window.location.origin
          })
        }
      );

      const data = await response.json();

      if (data.checkout_url) {
        window.location.href = data.checkout_url;
      } else {
        alert("Stripe error");
      }
    } catch (err) {
      console.error(err);
      alert("Bid failed");
    } finally {
      setSubmitting(false);
    }
  };

  const submitCryptoBid = async () => {
    if (!country) return;

    if (!termsAccepted) {
      alert("You must accept Terms & Conditions.");
      return;
    }

    try {
      setSubmitting(true);

      const token = localStorage.getItem("token");

      if (!token) {
        alert("Login first");
        return;
      }

     const response = await fetch(
  `${API_URL}/api/countries/${country?.country_code || country?.code}/crypto-bid`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            amount: Number(bidAmount),
            origin_url: window.location.origin
          })
        }
      );

      const data = await response.json();

      if (data.invoice_url) {
        window.location.href = data.invoice_url;
      } else {
        alert("Crypto error");
      }
    } catch (err) {
      console.error(err);
      alert("Crypto failed");
    } finally {
      setSubmitting(false);
    }
  };

  const handleBidderClick = async (bidder) => {
    if (bidder.user_id) {
      try {
        const res = await fetch(
          `${API_URL}/api/profile/${bidder.user_id}`
        );

        if (!res.ok) throw new Error();

        const fullProfile = await res.json();

        window.dispatchEvent(
          new CustomEvent("openProfile", {
        detail: {
  ...bidder,
  ...fullProfile,
  avatar: fullProfile.profile_image || bidder.avatar,
  country_name: country.country_name,
  country_code: country.country_code   // ✅ PRIDAJ
}
          })
        );

        return;
      } catch (err) {
        console.error(err);
      }
    }

    window.dispatchEvent(
      new CustomEvent("openProfile", {
     detail: {
  ...bidder,
  company_name: bidder.name,
  category: bidder.category || "Top Bidder",
  description: "Top bidder on this country.",
  avatar: bidder.avatar || null,
  country_name: country.country_name,
  country_code: country.country_code   // ✅ PRIDAJ AJ SEM
}
      })
    );
  };

  if (!country || !isOpen) return null;

  return (
    <>
      <style>{pulseStyle}</style>

      <div style={overlay}>
        <div style={modal(country, isMobile)}>
          <div style={bgOverlay} />

          <div style={{ position: "relative", zIndex: 2 }}>
            <button onClick={onClose} style={closeBtn}>
              <X size={20} />
            </button>

            <h2 style={title}>{country.country_name}</h2>

            <div style={{ color: "#aaa", marginBottom: 10 }}>
              <Users size={14} /> {bidders.length} bidders
            </div>

            <div style={{ maxHeight: "35vh", overflowY: "auto" }}>
              {loading && <p>Loading...</p>}

              {!loading &&
                bidders.map((b, i) => {
                  const isTop = i === 0;

                  return (
                    <div
                      key={i}
                      onClick={() => handleBidderClick(b)}
                      style={{
                        ...row,
                        ...(isTop && {
                          boxShadow: "0 0 10px rgba(255,215,0,0.5)",
                          borderRadius: "6px"
                        })
                      }}
                    >
                      <span
                        style={
                          isTop
                            ? {
                                color: "#FFD700",
                                fontWeight: "bold",
                                textShadow:
                                  "0 0 10px rgba(255,215,0,0.8), 0 0 20px rgba(255,215,0,0.5)",
                                animation: "goldPulse 1.2s infinite"
                              }
                            : {}
                        }
                      >
                        {isTop && <Crown size={12} color="#FFD700" />} #{b.position} {b.name}
                      </span>

                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          ...(isTop
                            ? {
                                color: "#FFD700",
                                fontWeight: "bold",
                                textShadow:
                                  "0 0 10px rgba(255,215,0,0.8), 0 0 20px rgba(255,215,0,0.5)",
                                animation: "goldPulse 1.2s infinite"
                              }
                            : {})
                        }}
                      >
                       {b.website?.trim() && <Globe size={14} color="inherit" />}
{b.linkedin?.trim() && <Linkedin size={14} color="inherit" />}
{b.instagram?.trim() && <Instagram size={14} color="inherit" />}
{b.facebook?.trim() && <Facebook size={14} color="inherit" />}
{b.tiktok?.trim() && <Music size={14} color="inherit" />}
{b.twitter?.trim() && <Twitter size={14} color="inherit" />}

                        <span style={{ color: "inherit", display: "flex", alignItems: "center" }}>
                          €{Number(b.amount).toFixed(2)}
                        </span>
                      </span>
                    </div>
                  );
                })}
            </div>

            <div style={{ display: "flex", gap: 10, marginTop: 15 }}>
              <input
                type="number"
                value={bidAmount}
                min="1"
                onChange={(e) => setBidAmount(e.target.value)}
                style={input}
              />
            </div>

            <div style={{ marginTop: 10, fontSize: "13px", color: "#aaa" }}>
              <label style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <input
                  type="checkbox"
                  checked={termsAccepted}
                  onChange={(e) => setTermsAccepted(e.target.checked)}
                />
                I agree to{" "}
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowTerms(true);
                  }}
                  style={{ color: "#FFD700", cursor: "pointer" }}
                >
                  Terms & Conditions
                </span>
              </label>
            </div>

            <div style={{ display: "flex", gap: 10, marginTop: 10 }}>
              <button onClick={submitBid} style={btn}>
                {submitting ? "..." : "💳 Card"}
              </button>

              <button onClick={submitCryptoBid} style={cryptoBtn}>
                🪙 Crypto
              </button>
            </div>
          </div>
        </div>
      </div>

      {showTerms && (
        <div style={overlay}>
          <div style={modal(country, isMobile)}>
            <div style={bgOverlay} />

            <div style={{ position: "relative", zIndex: 2 }}>
              <button onClick={() => setShowTerms(false)} style={closeBtn}>
                <X size={20} />
              </button>

              <h2 style={title}>Terms & Conditions</h2>

             <div style={{ color: "#ccc", fontSize: 13, maxHeight: "70vh", overflowY: "auto", paddingRight: 6 }}>
  <p><b>1. Introduction</b><br/>Welcome to TopNationApp.com. By accessing or using this website, you agree to be bound by these Terms and Conditions.</p>
  <p><b>2. Service Description</b><br/>TopNationApp is a competitive digital bidding and ranking platform where users place bids to achieve the highest ranking position for countries displayed on the world map.</p>
  <p><b>3. User Accounts</b><br/>Users must create an account to place bids. You are responsible for maintaining the confidentiality of your login credentials.</p>
  <p><b>4. Bidding Rules</b><br/>All bids are final and non-refundable.<br/>The highest bid determines the top-ranked position.<br/>Users may increase their bids at any time.<br/>TopNationApp reserves the right to remove fraudulent or abusive bids.</p>
  <p><b>5. Payments</b><br/>Payments are processed via Stripe.<br/>By placing a bid, you agree to pay the displayed amount.<br/>All transactions are secure and encrypted.</p>
  <p><b>6. Public Profiles and Rankings</b><br/>By participating in bidding and providing personal, company, or public profile information, users acknowledge and agree that:<br/>Their public profile name, company name, website, or custom display name may be publicly displayed on the platform.<br/>This information may be visible to other users worldwide.<br/>The purpose of the platform is to display public user profiles and rankings based on bidding activity.</p>
  <p><b>7. No Guarantee of Ownership</b><br/>Bidding does not grant legal ownership of any country. It represents a symbolic digital ranking within the platform.</p>
  <p><b>8. Content and Profiles</b><br/>Users may provide company names, website links, and public profile information. You agree not to submit unlawful, misleading, or inappropriate content.</p>
  <p><b>9. Platform Purpose</b><br/>TopNationApp is a competitive bidding and ranking platform. Users participate in a public leaderboard based on bidding activity. The platform does not offer advertising services or sponsored placements.</p>
  <p><b>10. Termination</b><br/>We reserve the right to suspend or terminate accounts that violate these terms.</p>
  <p><b>11. Limitation of Liability</b><br/>TopNationApp is provided "as is". We are not liable for any losses resulting from the use of the platform.</p>
  <p><b>12. Changes to Terms</b><br/>We may update these Terms at any time. Continued use of the platform means acceptance of the updated Terms.</p>
  <p><b>13. Contact</b><br/>For any questions, please contact us via the website.</p>
  <p style={{ marginTop: 10 }}>Last updated: July 2026</p>
</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

const pulseStyle = `
@keyframes goldPulse {
  0% { text-shadow: 0 0 6px rgba(255,215,0,0.6); }
  50% { text-shadow: 0 0 20px rgba(255,215,0,1); }
  100% { text-shadow: 0 0 6px rgba(255,215,0,0.6); }
}
`;

const overlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.7)",

  display: "flex",
  justifyContent: "center",

  alignItems: "flex-start",   // 🔥 ZMENA
  overflowY: "auto",          // 🔥 ZMENA
  padding: "20px 10px",       // 🔥 NOVÉ

  zIndex: 9999
};

const modal = (country, isMobile) => ({
  background: "#0A0A0A",
  border: "1px solid #FFD700",

  width: isMobile ? "88%" : "min(90%, 420px)",
  maxHeight: "90vh",

  padding: isMobile ? 12 : 18,
  borderRadius: isMobile ? 14 : 18,

  position: "relative",
  overflow: "auto",

  display: "flex",
  flexDirection: "column",

  backgroundImage: country?.top_bidders?.[0]?.avatar_url
    ? `url(${country.top_bidders[0].avatar_url})`
    : "none",

  backgroundSize: "cover",
  backgroundPosition: "center",

  filter: "brightness(0.85) contrast(1.2)"
});

const bgOverlay = {
  position: "absolute",
  inset: 0,
  borderRadius: 12,
  background: `
  linear-gradient(
    to bottom,
    rgba(0,0,0,0.45) 0%,
    rgba(0,0,0,0.55) 40%,
    rgba(0,0,0,0.85) 100%
  )
`
};

const closeBtn = {
  position: "absolute",
  top: 10,
  right: 10,
  background: "none",
  border: "none",
  color: "#FFD700",
  cursor: "pointer"
};

const title = {
  color: "#FFD700",
  marginBottom: 10
};

const row = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",   // 👈 TOTO
  padding: "6px 0",
  cursor: "pointer"
};

const input = {
  flex: 1,
  padding: 8,
  background: "#111",
  border: "1px solid #333",
  color: "white"
};

const btn = {
  flex: 1,
  background: "#FFD700",
  color: "#000",
  padding: "10px",
  border: "none",
  cursor: "pointer",
  fontWeight: "bold"
};

const cryptoBtn = {
  flex: 1,
  background: "#000",
  color: "#FFD700",
  padding: "10px",
  border: "2px solid #FFD700",
  cursor: "pointer",
  fontWeight: "bold"
};
